import outlookIcon from "../assets/icons/outlooksmall.png";
import wordIcon from "../assets/icons/word.png";
import searchIcon from "../assets/icons/searchsmall.png";
import syncContactIcon from "../assets/icons/syncContact.png";
import createNewDocIcon from "../assets/icons/createNewDoc.png";
import checkDocIcon from "../assets/icons/checkDoc.png";
import excelIcon from "../assets/icons/excel.png";
import powerpoint from "../assets/icons/powerpoint.png";
import textIcon from "../assets/icons/text.png";
import pdfIcon from "../assets/icons/pdf.png";
import pdfLockIcon from "../assets/icons/pdf-lock-arrow.png";
import notSupportedIcon from "../assets/icons/notSupported.png";
import wordLockIcon from "../assets/icons/word-lock-arrow.png";
import excelLockIcon from "../assets/icons/excel-lock-arrow.png";
import powerpointLockIcon from "../assets/icons/powerpoint-lock-arrow.png";
import messageIcon from "../assets/icons/outlooksmall.png";
import outlook from "../assets/icons/outlook.png";
import chromeIcon from "../assets/icons/chrome.png";
import wordReleasedIcon from "../assets/icons/word-released.png";
import excelReleasedIcon from "../assets/icons/exel-released.png";
import powerpointReleasedIcon from "../assets/icons/powerpoint-released.png";
import pdfReleasedIcon from "../assets/icons/pdf-released.png";
import outlookReleasedIcon from "../assets/icons/outlook-released.png";
import outlookLockIcon from "../assets/icons/outlook-lock-arrow.png";
import archive from "../assets/icons/archive.png";
import otherFileIcon from "../assets/icons/otherFile.png";
import audioFileIcon from "../assets/icons/audio.png";
import videoFileIcon from "../assets/icons/vedio.png";
import mergeDocsIcon from "../assets/icons/merge-docs.png";
import videoReleasedIcon from "../assets/icons/vedio-released.png";
import videoLockIcon from "../assets/icons/video-lock-arrow.png";
import imageIcon from "../assets/icons/image.png";
import imageLockIcon from "../assets/icons/image-lock-arrow.png";
import imageReleasedIcon from "../assets/icons/image-released.png";
import archiveLockIcon from "../assets/icons/archive-lock-arrow.png";
import archiveReleasedIcon from "../assets/icons/archive-released.png";
import textLockIcon from "../assets/icons/text-lock-arrow.png";
import textReleasedIcon from "../assets/icons/text-released.png";
import audioLockIcon from "../assets/icons/audio-lock-arrow.png";
import audioReleasedIcon from "../assets/icons/audio-released.png";

export const OAS365ICONS = {
  outlookIcon,
  wordIcon,
  searchIcon,
  syncContactIcon,
  createNewDocIcon,
  checkDocIcon,
  excelIcon,
  powerpoint,
  textIcon,
  pdfIcon,
  notSupportedIcon,
  wordLockIcon,
  excelLockIcon,
  powerpointLockIcon,
  messageIcon,
  outlook,
  chromeIcon,
  imageIcon,
  wordReleasedIcon,
  excelReleasedIcon,
  powerpointReleasedIcon,
  archive,
  otherFileIcon,
  audioFileIcon,
  videoFileIcon,
  mergeDocsIcon,
  pdfLockIcon,
  pdfReleasedIcon,
  outlookReleasedIcon,
  outlookLockIcon,
  videoReleasedIcon,
  videoLockIcon,
  imageLockIcon,
  imageReleasedIcon,
  archiveLockIcon,
  archiveReleasedIcon,
  textLockIcon,
  textReleasedIcon,
  audioLockIcon,
  audioReleasedIcon,
};
